export default "__VITE_ASSET__DjFasAH1__"